import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { VerticalsButtonsGroupData } from '../types'
import CTAButton from './CTAButton'
import React from 'react'

//sectionId is used for navigation
const VerticalsButtonsGroup: React.FC<{ data?: VerticalsButtonsGroupData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  if (!data) return null
  return (
    <>
      <Box
        id={sectionId}
        display="grid"
        gridTemplateColumns={[
          'repeat(2, minmax(0,max-content))',
          'repeat(4, minmax(0,max-content))'
        ]}
        gridColumnGap={['1.5rem', '1rem']} //alias for column-gap
        gridRowGap={['1.5rem', '1rem']} //alias for row-gap
        justifyContent="center"
        mx="auto"
      >
        {data.items?.map((item, idx) => (
          <CTAButton
            data-heap-id={`VerticalsButtonsGroup${idx}_CTAButton`}
            key={idx}
            iconSrc={item['icon-src'].url ?? ''}
            iconAlt={item['icon-src'].alt ?? undefined}
            href={item.href?.url}
            label={item.label}
            variant={item.variant}
            backgroundColor="secondary.backgroundDark"
            px={2}
            py={2}
            alignItems="center"
          />
        ))}
      </Box>
      <Spacer mb={{ _: '32px', md: '56px', lg: '96px' }} />
    </>
  )
}

export default VerticalsButtonsGroup
